import React from 'react';
import '../styles/StudioEditorOnly.css';

const EditorOnlyLayout = ({
  topContent,
  leftContent,
  rightContent,
  children,
  className = '',
}) => (
  <div className={`studio-page studio-editor-only ${className}`.trim()}>
    <header className="studio-topbar studio-editor-only-topbar">
      <div className="studio-editor-only-topbar-content">{topContent}</div>
    </header>
    <div className="studio-body studio-editor-only-body">
      <aside className="studio-sidebar studio-sidebar-left">{leftContent}</aside>
      <section className="studio-canvas">{children}</section>
      <aside className="studio-sidebar studio-sidebar-right">{rightContent}</aside>
    </div>
  </div>
);

export default EditorOnlyLayout;
